export const APP_CONFIG = {
  name: "Lawgentia",
  tagline: "Legal Intelligence",
  company: "Nolim Studios",
  version: "1.0.0",
  email: "nolimstudios@gmail.com",
  supportLabel: "Nolim Studios Support",
} as const;

export const FREE_CREDITS = 3;
export const PRO_CREDITS = 999999;

export {
  getCountryCodes,
  getCountryCodesSync,
  getCountries,
  getEnabledCountries,
  getCountry,
  isValidCountryCode,
  isCountryEnabled,
} from "./countries";

export {
  DOCUMENT_TYPES,
  getDocumentTypes,
  getDocumentTypeConfig,
  getDocumentFieldsByGroup,
} from "./document-types";

export const LIMITS = {
  free: {
    documents: FREE_CREDITS,
    storage: 10 * 1024 * 1024,
    maxDocumentLength: 5000,
  },
  pro: {
    documents: Infinity,
    storage: 100 * 1024 * 1024,
    maxDocumentLength: 20000,
  },
} as const;

export const PRICING = {
  free: { price: 0, name: "Free", interval: null },
  pro: { price: 29, name: "Pro", interval: "pro_monthly" },
} as const;

export const ROUTES = {
  HOME: "/",
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
  GENERATE: "/generate",
  DOCUMENT: "/document",
  PRICING: "/pricing",
  CHECKOUT: "/checkout",
  ABOUT: "/about",
  LEGAL: "/legal",
  TERMS: "/legal/terms",
  PRIVACY: "/legal/privacy",
  COOKIES: "/legal/cookies",
  SECURITY: "/legal/security",
  ADMIN: "/admin",
} as const;

export const API_ENDPOINTS = {
  GENERATE_DOCUMENT: "/api/generate",
  REVIEW_DOCUMENT: "/api/review",
  STRIPE_WEBHOOK: "/api/webhooks/stripe",
  STRIPE_CREATE_CHECKOUT: "/api/stripe/create-checkout",
} as const;

export const SOCIAL_LINKS = {
  twitter: "https://twitter.com/lawgentia",
  linkedin: "https://linkedin.com/company/lawgentia",
  github: "https://github.com/nolimstudios/lawgentia",
  email: "nolimstudios@gmail.com",
} as const;

export const SUPPORT_EMAIL = "nolimstudios@gmail.com" as const;
export const SUPPORT_LABEL = "Nolim Studios Support" as const;
